import React from 'react'
import { PropTypes } from 'prop-types'
import { HtmlHead, PageWrapper, PageContent, Footer, BurgerMenu, Button } from '../../ui'
import bem from '../../../common/bem'
import { checkIsError } from '../../../common/genericHelper'

import './CommunityPage.scss'


export default class DefaultPage extends React.Component {

  static defaultProps = {
    onMenuChange: () => {},
    curMenuState: false
  }

  static propTypes = {
    route: PropTypes.object,
    curMenuState: PropTypes.bool,
    onMenuChange: PropTypes.func
  };

  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  componentWillMount() {
    !this.props.curMenuState && this.props.onMenuChange && this.props.onMenuChange(null, true);
  }

  componentWillUpdate() {
    !this.props.curMenuState && this.props.onMenuChange && this.props.onMenuChange(null, true);
  }

  render() {
    const { curMenuState, onMenuChange, route } = this.props;
    const { html, title } = route;
    const isError = checkIsError(this.props);

    const bemmer = bem('communitypage');

    if(isError) this.context.router.push('/404')

    return(
      <PageWrapper isSidebarOpen={this.props.curMenuState}>
        <HtmlHead title={title} />
        <PageContent className={bem('defaultpage').element('content')}>
          <BurgerMenu curMenuState={curMenuState} onMenuChange={onMenuChange} />
          <div>
            <h1>Community &amp; Support</h1>

            <p>We’re here point you to the right direction for online groups and forums you find useful in
              your Serverless journey. These are external communities from SLS Zone but if you have questions
              for the developers who are making the SLS Zone content, you can speak to any one of us.
            </p>

            {/***SLS Zone twitter** - [link here]()*/}
            {/*Get updates on new content etc.*/}

            <div className={bemmer.element('serverless')}>
              <a className={bemmer.element('logo-serverless')} href="https://serverless.com"><img src="/images/logo-serverless.png"/></a>
              <ul>
                <li><a href="https://forum.serverless.com/">Serverless forum</a></li>
                <li><a href="https://gitter.im/serverless/serverless">Serverless gitter</a></li>
                <li><a href="https://www.reddit.com/r/serverless/">Serverless Sub-reddit</a></li>
              </ul>
            </div>

          </div>
        </PageContent>
        <Footer />
      </PageWrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./component/page/CommunityPage/CommunityPage.js